import classNames from 'classnames';
import { useRef, useState } from 'react';
import * as bd from 'react-basic-design';
import SvgEditPhoto from '../../assets/icons/EditPhoto';
import { T } from '../basic/text';

interface DragDropZoneProps {
    onFileDrop: (file: File) => Promise<void>;
    readOnly?: boolean;
    accept?: string;
    imageUrl?: string;
    className?: string;
    children?: React.ReactNode;
}

export const DragDropZone = ({
    onFileDrop,
    readOnly,
    accept = '.zip',
    imageUrl,
    className,
    children,
}: DragDropZoneProps) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [isDragging, setIsDragging] = useState(false);

    const handleDragOver = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(true);
    };

    const handleDragLeave = (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);
    };

    const handleDrop = async (e: React.DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        setIsDragging(false);

        const file = e.dataTransfer.files[0];
        await onFileDrop(file);
    };

    const handleFileInputChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            await onFileDrop(file);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    };

    return (
        <bd.Flex
            vertical
            className={classNames(
                'h-100 d-flex flex-column bg-white position-relative',
                className,
                {
                    'border-primary': isDragging,
                }
            )}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
        >
            <input
                type="file"
                accept={accept}
                onChange={handleFileInputChange}
                ref={fileInputRef}
                className="d-none"
            />
            {children || (
                <bd.Flex
                    align="start"
                    content="start"
                    className="w-100 flex-grow-1"
                    style={{ position: 'relative' }}
                >
                    <img
                        src={imageUrl || '/productPlaceHolder.svg'}
                        alt="uploaded"
                        className="border rounded"
                        style={{
                            width: '150px',
                            height: '150px',
                            marginBottom: 8,
                        }}
                    />

                    {!readOnly && (
                        <bd.Button
                            type="button"
                            variant="icon"
                            color="secondary"
                            size="sm"
                            className="position-absolute"
                            style={{
                                top: 1,
                                right: 1,
                            }}
                            disableRipple
                            onClick={() => fileInputRef.current?.click()}
                        >
                            <SvgEditPhoto />
                        </bd.Button>
                    )}
                </bd.Flex>
            )}
        </bd.Flex>
    );
};
